// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gpn7","content":"styles_content__Jp4kF"};